import { ContainerClient } from "@azure/storage-blob"; 
import API from "./api";
import FileMetaData from "../helpers/FileMetaData";

const api = API.create();

const AssetsURL = `https://${import.meta.env.VITE_BLOB_ACCOUNT}.blob.core.windows.net/${import.meta.env.VITE_BLOB_CONTAINER}`;

const sasUrl = `${AssetsURL}${import.meta.env.VITE_BLOB_SAS}`;

const containerClient = new ContainerClient(sasUrl);

const buildFileName = (file, subdirectory, hash) => {
    if (!file?.name) return null;

    const fileName = file.name.toLowerCase().replace(/[^a-zA-Z0-9.]/g, '_'); // Sanitize file name

    return `${subdirectory}${hash}/${fileName}`;
}

async function uploadFile(file, subdirectory = 'attachments/')  {
    const hash = await api.getGenerateHash();
    if (!hash.data) return null;

    const fileName = buildFileName(file, subdirectory, hash.data);
    
    const blockBlobClient = containerClient.getBlockBlobClient(fileName);
    const uploadOptions = {blobHTTPHeaders: { blobContentType: file.type },};// Set content type if available

    const response = await blockBlobClient.uploadData(file, uploadOptions);

    if (response._response.status === 201) {
        return {
            name: fileName,
            url: `https://${import.meta.env.VITE_BLOB_ACCOUNT}.blob.core.windows.net/${import.meta.env.VITE_BLOB_CONTAINER}/${fileName}`,
            hash: hash.data,
            meta: new FileMetaData(file)
        };
    }

    return null
}

export { uploadFile, AssetsURL };